/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type PdpSharedDetailPayments_viewer$ref = any;
export type PdpSharedDetailPayments_viewer = {
    readonly affirmEnabled: boolean | null;
    readonly regionalInfo: ReadonlyArray<{
        readonly countryCode: string | null;
    } | null> | null;
    readonly " $refType": PdpSharedDetailPayments_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpSharedDetailPayments_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": "affirmEnabled",
            "name": "isEnabledByLocale",
            "args": [
                {
                    "kind": "Literal",
                    "name": "featureName",
                    "value": "AFFIRM"
                }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"AFFIRM\")"
        },
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "regionalInfo",
            "storageKey": null,
            "args": null,
            "concreteType": "RegionalInfo",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "countryCode",
                    "args": null,
                    "storageKey": null
                }
            ]
        }
    ]
} as any);
(node as any).hash = '334901cf51da8cf065254fbdf052ad03';
export default node;
